import { z } from 'zod';
import { storageLocationsSortByValues } from 'src/apis/storage/mappings';
import {
  descSortDirectionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';

export function getStorageLocationsPageParamsSchema() {
  return z
    .object({
      sortBy: z.enum(storageLocationsSortByValues).default('NAME'),
      sortDirection: descSortDirectionSchema,
      name: z.string().nullable().default(null),
      locationBusinessId: z.string().nullable().default(null),
      ssoName: z.string().nullable().default(null),
      marketArea: z.string().nullable().default(null),
    })
    .merge(getPaginationSchema());
}
